import { Grid, Typography } from '@mui/material';
import CustomCircularProgress from 'components/common/CustomCircularProgress';

const styles = {
  spinner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '200px',
    maxHeight: '100vh',
    height: '100%',
    flexDirection: 'column',
  },
};

export const LoadingSpinner = ({ message }: { message: string }) => {
  return (
    <Grid data-testid="loading-spinner" id={'loading-spinner'} sx={styles.spinner}>
      <Typography sx={{ mb: 2 }} variant={'h4'}>
        {message}
      </Typography>
      <CustomCircularProgress size={30} />
    </Grid>
  );
};
